// @flow
import { useState } from 'react';
import map from 'ramda/es/map';
import range from 'ramda/es/range';

import type { Discipline } from 'app/dataTypes/Discipline.types';


export type DisciplineUpdater = (
  | ((Array<Discipline>) => Array<Discipline>)
  | Array<Discipline>
) => void

const disciplinesDefault: Array<Discipline> = map(id => ({ id, title: '' }), range(1, 12));

export default function useDisciplines(): [Array<Discipline>, DisciplineUpdater] {
  const [disciplines, setDisciplines] = useState<Array<Discipline>>(disciplinesDefault);

  return [disciplines, setDisciplines];
}
